function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import Shopping from "./Shopping";
import styles from "./Shopping.module.css";
import useWeeeShopping from "./useWeeeShopping";
import { weeeAdapter } from "./shoppingItemAdapter";
var WeeeShoppingItem = function WeeeShoppingItem(_ref) {
  var _onClick = _ref.onClick,
    shoppingItemInfo = _ref.shoppingItemInfo;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.ShoppingItem,
    onClick: function onClick() {
      return _onClick(shoppingItemInfo);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.shoppingItemImgWrapper
  }, /*#__PURE__*/React.createElement("img", {
    src: shoppingItemInfo.img,
    alt: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.ShoppingItemInfo
  }, /*#__PURE__*/React.createElement("div", null, shoppingItemInfo.name), /*#__PURE__*/React.createElement("span", null, "$ ", shoppingItemInfo.price)));
};
var WeeeShopping = function WeeeShopping(props) {
  return /*#__PURE__*/React.createElement(Shopping, _extends({}, props, {
    shoppingType: "weee",
    useShopping: useWeeeShopping,
    shoppingItem: WeeeShoppingItem,
    adapter: weeeAdapter
  }));
};
export { WeeeShopping };